import { Account } from '../../../types';
import { callExternalApi } from '../../callExternalApi';
import { ApiAdvancedFilter, PaginatedResponse } from '../../../store/GeneralStore';
import { buildAdvancedQueryURL } from '../../../utils/helpers';

export const getAdminAccounts = async (filters?: ApiAdvancedFilter) => {
  const mergedFilters: ApiAdvancedFilter = {
    page: 1,
    pageSize: 50,
    sort: 'name',
    direction: 'desc',
    ...filters
  };

  return await callExternalApi<PaginatedResponse<Account>>({
    url: buildAdvancedQueryURL(mergedFilters, 'api/admin/fetch_accounts'),
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};
